module.exports = __webpack_public_path__ + "img/40-2-t.0eb9539c.png";